import Footer from './Components/Footer';
import Header from './Components/HomePage/Header';
import Main from './Components/HomePage/Main';
const HomePage = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default HomePage;
